import { render } from "./CreateApp.vue?vue&type=template&id=53605afa&ts=true"
import script from "./CreateApp.vue?vue&type=script&lang=ts"
export * from "./CreateApp.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__